import { inject } from "aurelia";
import { I18N, Signals } from "@aurelia/i18n";
import { isValid, toDate } from "../../common/dates";

@inject(I18N)
export class HumanizeValueConverter {
  signals = [Signals.I18N_SIGNAL];

  constructor(i18n) {
    this.i18n = i18n;
  }

  toView(value) {
    const date = toDate(value);
    if (!isValid(date)) return "Invalid date";
    return this.i18n.rt(date);
  }
}
